import React from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Divider,
  Chip
} from '@mui/material';
import {
  FolderOpen,
  VpnKey,
  Settings,
  Category,
  Person,
  Business
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const tenantMenuItems = [
  {
    text: '파일 온톨로지 현황',
    icon: <FolderOpen />,
    path: '/tenant/ontology'
  },
  {
    text: '데이터 시스템 접속정보 관리',
    icon: <VpnKey />,
    path: '/tenant/connection-info'
  },
  {
    text: 'Settings',
    icon: <Settings />,
    path: '/tenant/settings'
  }
];

const TenantSidebar = ({ onClose, isAdmin = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userProfile, tenantName } = useAuth();

  const handleNavigation = (path) => {
    navigate(path);
    if (onClose) {
      onClose();
    }
  };

  const isSelected = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <Box>
      {/* Logo/Title */}
      <Toolbar>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Category color="primary" />
          <Typography variant="h6" noWrap component="div" color="primary">
            Ontology
          </Typography>
        </Box>
      </Toolbar>
      
      <Divider />

      {/* Tenant Info */}
      <Box sx={{ p: 2, bgcolor: 'primary.light', color: 'white' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
          <Business fontSize="small" />
          <Typography variant="body2" fontWeight="medium">
            {tenantName || 'My Company'}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Person fontSize="small" />
          <Typography variant="caption">
            {userProfile?.displayName || 'User'}
          </Typography>
          <Chip
            label={userProfile?.role === 'tenant_admin' ? '관리자' : '사용자'}
            size="small"
            variant="outlined"
            sx={{ 
              fontSize: '0.7rem',
              height: 18,
              color: 'inherit',
              borderColor: 'rgba(255,255,255,0.5)',
              '& .MuiChip-label': { px: 0.5 }
            }}
          />
        </Box>
      </Box>

      <Divider />

      {/* Navigation Menu */}
      <List>
        {tenantMenuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              selected={isSelected(item.path)}
              onClick={() => handleNavigation(item.path)}
              sx={{
                '&.Mui-selected': {
                  backgroundColor: 'primary.main',
                  color: 'white',
                  '& .MuiListItemIcon-root': {
                    color: 'white',
                  },
                  '&:hover': {
                    backgroundColor: 'primary.dark',
                  },
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 40 }}>
                {item.icon}
              </ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      {/* Security Notice */}
      <Box sx={{ p: 2, mt: 'auto' }}>
        <Box sx={{ 
          p: 1,
          bgcolor: 'success.light',
          color: 'success.contrastText',
          borderRadius: 1,
          textAlign: 'center'
        }}>
          <Typography variant="caption" display="block">
            🔒 보안 격리됨
          </Typography>
          <Typography variant="caption">
            귀하의 데이터만 접근 가능
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default TenantSidebar;